/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRequestResponse } from './AccessRequestResponse';
import {
    AccessRequestResponseFromJSON,
    AccessRequestResponseFromJSONTyped,
    AccessRequestResponseToJSON,
    AccessRequestResponseToJSONTyped,
} from './AccessRequestResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface AccessRequestResponsePagedResult
 */
export interface AccessRequestResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof AccessRequestResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<AccessRequestResponse>}
     * @memberof AccessRequestResponsePagedResult
     */
    data: Array<AccessRequestResponse> | null;
}

/**
 * Check if a given object implements the AccessRequestResponsePagedResult interface.
 */
export function instanceOfAccessRequestResponsePagedResult(value: object): value is AccessRequestResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AccessRequestResponsePagedResultFromJSON(json: any): AccessRequestResponsePagedResult {
    return AccessRequestResponsePagedResultFromJSONTyped(json, false);
}

export function AccessRequestResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(AccessRequestResponseFromJSON)),
    };
}

export function AccessRequestResponsePagedResultToJSON(json: any): AccessRequestResponsePagedResult {
    return AccessRequestResponsePagedResultToJSONTyped(json, false);
}

export function AccessRequestResponsePagedResultToJSONTyped(value?: AccessRequestResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(AccessRequestResponseToJSON)),
    };
}

